import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'common-neighbour-icon',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './neighbour-icon.component.html',
  styleUrls: ['./neighbour-icon.component.scss'],
})
export class NeighbourIconComponent {
  @Input() color!: string;
}
